/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElAlert as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/alert/style/css';
import { ElInput as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElSelect as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "message-manage"
};
const _hoisted_2 = {
  class: "flex justify-between"
};
const _hoisted_3 = {
  class: "flex"
};
const _hoisted_4 = {
  class: "dialog-footer"
};
const _hoisted_5 = {
  class: "dialog-footer"
};
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiUsdkGetSmsList, apiUsdkSaveSmsList, apiUsdkSetSmsIpWhiteList, apiUsdkGetSmsIpWhiteList } from '@/api/usdk';
import { useAppStore } from '@/store/modules/app';
import GameChannelSelect from '@/components/GameChannelSelect/index.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'messageManage',
  setup(__props) {
    const useApp = useAppStore();
    const gameInfo = computed(() => useApp.gameInfo);
    const options = [{
      value: '',
      label: '全部'
    }, {
      value: 'lc.content.login',
      label: '登录手机短信'
    }, {
      value: 'lc.content.bind',
      label: '绑定手机短信'
    },
    // { value: 'lc.content.find', label: '找回密码短信' },
    {
      value: 'lc.content.find',
      label: '找回密码短信'
    }, {
      value: 'lc.logout',
      label: '注销账号短信'
    }, {
      value: 'lc.logout.s.master',
      label: '注销通行证成功'
    }, {
      value: 'lc.logout.s.sub',
      label: '注销小号成功'
    }];
    const optionsFrom = [{
      value: 'lc.content.login',
      label: '登录手机短信'
    }, {
      value: 'lc.content.bind',
      label: '绑定手机短信'
    }, {
      value: 'lc.content.find',
      label: '找回密码短信'
    }, {
      value: 'lc.logout',
      label: '注销账号短信'
    }, {
      value: 'lc.logout.s.master',
      label: '注销通行证成功'
    }, {
      value: 'lc.logout.s.sub',
      label: '注销小号成功'
    }];
    const fromValueContent = {
      'lc.content.login': '【公司名称】验证码：%1$s，%2$s内有效，您正在登录「应用名称」，切勿将此验证码转发或告知他人。若非本人操作，请忽略本短信。',
      'lc.content.bind': '【公司名称】验证码：%1$s，%2$s内有效，您正在为「应用名称」绑定手机号，切勿将此验证码转发或告知他人。若非本人操作，请忽略本短信。',
      'lc.logout': '【公司名称】验证码：%1$s，%2$s内有效，您正在为「应用名称」找回密码，切勿将此验证码转发或告知他人。若非本人操作，请忽略本短信。'
    };
    const columns = [{
      label: '渠道ID',
      prop: 'cid'
    }, {
      label: '渠道名称',
      prop: 'cname'
    }, {
      label: '短信事件',
      prop: 'descr'
    }, {
      label: '短信内容',
      prop: 'content'
    }, {
      label: '操作',
      action: true
    }];
    const filter = ref({
      cid: undefined,
      var: ''
    });
    const formRef = ref();
    const dialogVisible = ref(false);
    const form = ref({
      cids: [],
      var: '',
      content: ''
    });
    const confirmLoading = ref(false);
    const getTableData = () => {
      tableLoading.value = true;
      apiUsdkGetSmsList({
        gid: gameInfo.value.Id,
        ...filter.value
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const onChange = () => {
      form.value.content = fromValueContent[form.value.var] || '';
    };
    const {
      tableData,
      tableLoading
    } = UseTable(getTableData);
    const handleClick = row => {
      if (row) {
        form.value = JSON.parse(JSON.stringify(row));
        form.value.cids = [Number(row.cid)];
      } else {
        form.value = {
          cids: [],
          var: '',
          content: ''
        };
      }
      dialogVisible.value = true;
    };
    const handleClose = formEl => {
      dialogVisible.value = false;
      if (!formEl) return;
      formEl.resetFields();
    };
    const handleOk = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          confirmLoading.value = true;
          let params = JSON.parse(JSON.stringify(form.value));
          params.cids = params.cids.join(',');
          params.gid = gameInfo.value.Id;
          apiUsdkSaveSmsList(params).then(res => {
            if (res.code === 0) {
              getTableData();
              handleClose(formRef.value);
            }
          }).finally(() => {
            confirmLoading.value = false;
          });
        }
      });
    };
    watch(() => gameInfo.value, val => {
      if (val && val.Id) {
        getTableData();
      }
    }, {
      immediate: true,
      deep: true
    });
    /**
     *  短信白名单逻辑
     */
    const formIp = ref({
      ip: ''
    });
    const formIpRef = ref();
    const messageIpVisible = ref(false);
    const handleOpenModal = async () => {
      messageIpVisible.value = true;
      const res = await apiUsdkGetSmsIpWhiteList({
        gid: gameInfo.value.Id
      });
      if (res.code === 0) {
        formIp.value.ip = res.data.data;
      }
    };
    const handleCloseIp = () => {
      if (!formIpRef.value) return;
      formIpRef.value.resetFields();
      messageIpVisible.value = false;
    };
    const handleOkIp = () => {
      var _formIpRef$value;
      (_formIpRef$value = formIpRef.value) === null || _formIpRef$value === void 0 ? void 0 : _formIpRef$value.validate(async valid => {
        if (valid) {
          messageIpVisible.value = false;
          const res = await apiUsdkSetSmsIpWhiteList({
            gid: gameInfo.value.Id,
            ip: formIp.value.ip
          });
          if (res.code === 0) {
            handleCloseIp();
          }
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_form_item = __unplugin_components_0;
      const _component_el_option = __unplugin_components_1;
      const _component_el_select = __unplugin_components_2;
      const _component_el_form = __unplugin_components_3;
      const _component_el_button = __unplugin_components_4;
      const _component_el_input = __unplugin_components_5;
      const _component_el_alert = __unplugin_components_6;
      const _component_el_dialog = __unplugin_components_7;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "所属渠道"
        }, {
          default: _withCtx(() => [_createVNode(GameChannelSelect, {
            modelValue: _unref(filter).cid,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).cid = $event),
            gid: _unref(gameInfo).Id,
            otherProps: {
              isHero: 1
            }
          }, null, 8, ["modelValue", "gid"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "marginL20",
          label: "短信事件"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(filter).var,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(filter).var = $event),
            filterable: "",
            placeholder: "请选择短信事件"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, item => {
              return _createVNode(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_button, {
        class: "marginL20",
        type: "primary",
        onClick: getTableData
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[2] || (_cache[2] = $event => handleOpenModal())
      }, {
        default: _withCtx(() => [_createTextVNode("短信IP白名单")]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => handleClick())
      }, {
        default: _withCtx(() => [_createTextVNode("批量配置")]),
        _: 1
      })])]), _createVNode(UTable, {
        options: columns,
        data: _unref(tableData),
        loading: _unref(tableLoading)
      }, {
        action: _withCtx(({
          scope
        }) => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleClick(scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("修改")]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 8, ["data", "loading"])]), _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "修改",
        width: "600px",
        "before-close": () => handleClose(_unref(formRef))
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = $event => handleClose(_unref(formRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[10] || (_cache[10] = $event => handleOk(_unref(formRef))),
          loading: _unref(confirmLoading)
        }, {
          default: _withCtx(() => [_createTextVNode("确定 ")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(form),
          ref_key: "formRef",
          ref: formRef,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "cids",
            label: "所属渠道",
            rules: {
              required: true,
              message: '请选择渠道',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(GameChannelSelect, {
              modelValue: _unref(form).cids,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(form).cids = $event),
              gid: _unref(gameInfo).Id,
              multiple: "",
              otherProps: {
                isHero: 1
              },
              style: {
                "width": "100%"
              }
            }, null, 8, ["modelValue", "gid"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "var",
            label: "短信事件",
            rules: {
              required: true,
              message: '请选择短信事件',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              onChange: onChange,
              modelValue: _unref(form).var,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).var = $event),
              filterable: "",
              placeholder: "请选择短信事件",
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(optionsFrom, item => {
                return _createVNode(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "content",
            label: "短信内容",
            rules: {
              required: true,
              message: '请选择短信内容',
              trigger: 'blur'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).content,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(form).content = $event),
              type: "textarea",
              maxLength: 100,
              autosize: {
                minRows: 2,
                maxRows: 4
              },
              placeholder: "请输入短信内容",
              onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
            }, null, 8, ["modelValue"])]),
            _: 1
          }), false ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "预览"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).content,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(form).content = $event),
              type: "textarea",
              disabled: "",
              autosize: {
                minRows: 2,
                maxRows: 4
              },
              placeholder: "预览"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"]), _createVNode(_component_el_alert, {
          type: "warning",
          closable: false,
          title: "备注：%1$s是验证码，%2$s是时效。短信内容中必须存在这两个变量参数"
        })]),
        _: 1
      }, 8, ["modelValue", "before-close"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(messageIpVisible),
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _isRef(messageIpVisible) ? messageIpVisible.value = $event : null),
        title: "短信IP白名单",
        width: "600px",
        "before-close": handleCloseIp
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: handleCloseIp
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleOkIp
        }, {
          default: _withCtx(() => [_createTextVNode("确定 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_alert, {
          type: "warning",
          closable: false,
          title: "作用：用于游戏测试阶段，接触同一IP引起的短信服务限制"
        }), _createVNode(_component_el_form, {
          ref_key: "formIpRef",
          ref: formIpRef,
          model: _unref(formIp),
          class: "marginT20",
          "label-width": "80px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "ip",
            label: "IP白名单",
            rules: {
              required: true,
              message: '请输入IP白名单',
              trigger: 'blur'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(formIp).ip,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(formIp).ip = $event),
              type: "textarea",
              maxLength: 10000,
              autosize: {
                minRows: 4,
                maxRows: 8
              },
              placeholder: "请输入IP地址，多个IP使用,间隔"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});